var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFichaTecnica(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1137",
    "data-name": "Group 1137",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.564,
    height: 31.463,
    viewBox: "0 0 23.564 31.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fafafa;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-1",
    d: "M453.911,261.858V256h-.066a.922.922,0,0,0-.652.27l-5.924,5.924a.922.922,0,0,0-.27.652v.066h5.859a1.054,1.054,0,0,0,1.053-1.053Zm0,0",
    transform: "translate(-447 -256)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-1",
    d: "M467.668,256H455.755v5.858a2.9,2.9,0,0,1-2.9,2.9H447v19.812a2.9,2.9,0,0,0,2.9,2.9h17.772a2.9,2.9,0,0,0,2.9-2.9V258.9a2.9,2.9,0,0,0-2.9-2.9Zm-13.487,16.067a.922.922,0,0,1,1.3,0l2.376,2.376v-6.66a.922.922,0,1,1,1.843,0v6.66l2.376-2.376a.922.922,0,1,1,1.3,1.3l-3.949,3.949a.922.922,0,0,1-1.3,0l-3.949-3.949a.922.922,0,0,1,0-1.3Zm8.55,9.472h-7.9a.922.922,0,0,1,0-1.844h7.9a.922.922,0,0,1,0,1.844Zm0,0",
    transform: "translate(-447 -256)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFichaTecnica);
export default __webpack_public_path__ + "static/media/Icon_FichaTecnica.74390be78066abaa4f95b3fa00721974.svg";
export { ForwardRef as ReactComponent };